/** UnityProgressBar: branded full-screen loading overlay shown while the
 *  Unity WebGL build downloads/initializes. */
interface UnityProgressBarProps {
  loading: boolean;
  progress: number;
}

const LOGO_URL = '/modules/ubercabinet/views/images/uc-logo.png';
const BEIGE = '#E6DBCA';
const CANVAS_BG = '#231F20';

const UnityProgressBar: React.FC<UnityProgressBarProps> = ({ loading, progress }) => {
  if (!loading) return null;

  const pct = Math.max(0, Math.min(100, Math.round(progress * 100)));

  return (
    <div
      id="unity-loading-bar"
      style={{
        position: 'absolute',
        inset: 0,
        zIndex: 100,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: CANVAS_BG,
      }}
    >
      <div
        id="unity-logo"
        style={{
          width: 240,
          height: 127,
          backgroundImage: `url('${LOGO_URL}')`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundSize: 'contain',
        }}
      />
      <div
        id="unity-progress-bar-empty"
        style={{
          width: 190,
          height: 8,
          marginTop: 18,
          background: 'rgba(230, 219, 202, 0.25)',
          borderRadius: 4,
          overflow: 'hidden',
        }}
      >
        <div
          id="unity-progress-bar-full"
          style={{
            width: `${pct}%`,
            height: '100%',
            background: BEIGE,
            borderRadius: 4,
            transition: 'width 0.15s ease-out',
          }}
        />
      </div>
    </div>
  );
};

export default UnityProgressBar;
